import { ChangeEvent } from 'react';
import { SelectChangeEvent, Stack, styled, Typography } from '@mui/material';
import { TableCustom } from 'app/components/elements/TableCustom';
import { InputSelect } from 'app/components/elements/InputSelect';
import { InputText } from 'app/components/elements/InputText';
import {
  IssuesFiltersBar,
  IssuesFilterField,
  IssuesSearchField,
  filterFieldSx
} from 'app/pages/IssuesPage/components/IssuesFiltersBar';
import { useCompletedMaintenanceInjection } from './hook';
import {
  buildCompletedMaintenanceRow,
  COMPLETED_MAINTENANCE_TABLE_HEADERS,
  exportCompletedMaintenanceCsv,
  useCompletedMaintenanceFilters
} from './completedMaintenanceTable';

export const CompletedMaintanence = () => {
  const { issues, loading } = useCompletedMaintenanceInjection();
  const {
    search,
    setSearch,
    client,
    setClient,
    clientOptions,
    location,
    setLocation,
    locationOptions,
    assignedTo,
    setAssignedTo,
    assignedToOptions,
    filteredIssues,
    hasActiveFilters,
    clearFilters
  } = useCompletedMaintenanceFilters(issues);

  const dataTable = filteredIssues.map(buildCompletedMaintenanceRow);

  return (
    <TabContentContainer>
      <Typography fontSize={24} fontWeight={700} color="#226AAA">
        Completed Maintenance
      </Typography>

      <IssuesFiltersBar
        showClearFilters={hasActiveFilters}
        onClearFilters={clearFilters}
        onExportCsv={() => exportCompletedMaintenanceCsv('completed-maintenance', filteredIssues)}>
        <IssuesSearchField>
          <InputText
            placeholder="Search asset, client, location, assignee…"
            inputProps={{
              value: search,
              onChange: (e: ChangeEvent<HTMLInputElement>) => setSearch(e.target.value),
              style: { minHeight: '46px', height: '46px', padding: 0 }
            }}
          />
        </IssuesSearchField>
        <IssuesFilterField>
          <InputSelect
            placeholder="All Clients"
            sx={filterFieldSx}
            value={client}
            onChange={(e: SelectChangeEvent<unknown>) =>
              setClient((e.target.value as string) || '')
            }
            options={clientOptions}
          />
        </IssuesFilterField>
        <IssuesFilterField>
          <InputSelect
            placeholder="All Locations"
            sx={filterFieldSx}
            value={location}
            onChange={(e: SelectChangeEvent<unknown>) =>
              setLocation((e.target.value as string) || '')
            }
            options={locationOptions}
          />
        </IssuesFilterField>
        <IssuesFilterField>
          <InputSelect
            placeholder="All Assignees"
            sx={filterFieldSx}
            value={assignedTo}
            onChange={(e: SelectChangeEvent<unknown>) =>
              setAssignedTo((e.target.value as string) || '')
            }
            options={assignedToOptions}
          />
        </IssuesFilterField>
      </IssuesFiltersBar>

      {!loading && filteredIssues.length === 0 ? (
        <Typography color="#6B7280">No completed maintenance records found.</Typography>
      ) : (
        <TableCustom
          handleChooseRow={() => {}}
          headers={COMPLETED_MAINTENANCE_TABLE_HEADERS}
          data={dataTable}
          isScrollX
        />
      )}
    </TabContentContainer>
  );
};

const TabContentContainer = styled(Stack)(() => ({
  flex: 1,
  gap: 10,
  paddingTop: 40,
  paddingBottom: 40
}));
